export const pleaseAddCommentText = "Please add comment text";
export const invalidYouTubeURL = "This YouTube URL is incorrect. Please try again.";
export const pleaseAddPhotoOrVideo = "Please add photo or video below"
export const unknownError = "Oops, something has gone wrong and we're not sure what. Please try again later.";
export const notSignedIn = "You are not currently signed in";
export const noListEntryFound = "No name for this Entry";